/* ================================================== */
/* SEARCH > Inits
/* ================================================== */

var $openCtrl        = $('.link--search'),
	$closeCtrl       = $('.link--close'),
	searchClass      = '.search',
	$searchContainer = $(searchClass),
	$formSearch      = $('.search__form'),
	$inputSearch     = $('.search__input'),
	lastFocusedElement;